import { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import api from 'utils/api';
import { useNavigate } from 'react-router-dom';
import Container from 'components/common/Container';
import CustomLink from 'components/common/CustomLink';
import { clearAuth, loadSession, useAuth } from 'utils/auth';
import Signup from './Signup';

export default function NusSignIn() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const [signup, setSignup] = useState(
    () => sessionStorage.getItem('nus-signup') === 'true'
  );

  useEffect(() => {
    if (session?.status === 'authenticated') {
      sessionStorage.removeItem('nus-signup');
      window.myAntsTag?.('SET', 'userId', String(session.user.userId));
      window.myAntsTag?.('EVENT', 'LOGIN');
      navigate('/data', { replace: true });
    }
  }, [session, navigate]);

  // Registration rotates the session and CSRF token on the backend.
  const complete = async () => {
    const updated = await loadSession(true);
    if (updated?.status !== 'authenticated') throw new Error('Sign-in expired');
  };

  if (session?.status === 'profile_required') {
    if (!signup) {
      return (
        <Container style={{ marginTop: 48, marginBottom: 48, minHeight: 320 }}>
          <Typography variant='h2' color='blue.900'>
            Create an account to continue
          </Typography>
          <Typography sx={{ my: 3 }}>
            Your NUS sign-in was successful. Please sign up to create an Ombak
            account for {session.email}.
          </Typography>
          <Button
            variant='primary'
            onClick={() => {
              sessionStorage.setItem('nus-signup', 'true');
              setSignup(true);
            }}
          >
            Sign up for an account
          </Button>
        </Container>
      );
    }
    return (
      <Signup
        nusEmail={session.email}
        onComplete={complete}
        onBack={async () => {
          // End the verified registration session before allowing a different email.
          await api.post('/public/oidc/logout');
          clearAuth();
          sessionStorage.removeItem('nus-signup');
          navigate('/signup', { replace: true });
        }}
      />
    );
  }
  if (session?.status === 'authenticated') return null;
  return (
    <Container style={{ marginTop: 48, marginBottom: 48 }}>
      <Alert severity='error'>
        Your NUS sign-in has expired.{' '}
        <CustomLink to='/login'>Log in again</CustomLink>.
      </Alert>
    </Container>
  );
}
